// src/lib/maps/mapConfig.js
export const MAP_DEFAULT_CENTER_NA = { lat: 39.5, lng: -98.35 };
export const MAP_DEFAULT_ZOOM_NA = 4;

// ✅ CRA will inline this at build time (no optional chaining)
export const GOOGLE_MAPS_API_KEY =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY) ||
  "";

// ✅ Single helper used by GoogleMapContainer
export const getGoogleMapsApiKey = () => {
  const baked = (GOOGLE_MAPS_API_KEY || "").trim();
  if (baked) return baked;

  // runtime fallback if you ever want it
  if (typeof window !== "undefined" && window.__GOOGLE_MAPS_API_KEY) {
    return String(window.__GOOGLE_MAPS_API_KEY).trim();
  }

  return "";
};
